import { normalizeLogin } from './login';

export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 32;

const PRINTABLE_ASCII = /^[\x21-\x7E]+$/;
const HAS_LETTER = /[a-zA-Z]/;
const HAS_DIGIT = /\d/;

export function sanitizePasswordInput(value, maxLength = PASSWORD_MAX_LENGTH) {
    return String(value ?? '').slice(0, maxLength);
}

export function getPasswordFormatError(password, { strict = false, login } = {}) {
    if (!password) {
        return 'Введите пароль';
    }
    if (password.length < PASSWORD_MIN_LENGTH) {
        return `Пароль — не короче ${PASSWORD_MIN_LENGTH} символов`;
    }
    if (password.length > PASSWORD_MAX_LENGTH) {
        return `Пароль — не длиннее ${PASSWORD_MAX_LENGTH} символов`;
    }
    if (!strict) {
        return null;
    }
    if (/\s/.test(password)) {
        return 'Пароль без пробелов';
    }
    if (!PRINTABLE_ASCII.test(password)) {
        return 'Только латиница, цифры и обычные знаки';
    }
    if (!HAS_LETTER.test(password) || !HAS_DIGIT.test(password)) {
        return 'Нужна хотя бы одна буква и одна цифра';
    }
    if (login && password === normalizeLogin(login)) {
        return 'Пароль не должен совпадать с логином';
    }
    return null;
}

export function isValidPasswordFormat(password, options) {
    return getPasswordFormatError(password, options) === null;
}

export function getPasswordInlineError(password, { login } = {}) {
    if (!password) return '';
    return getPasswordFormatError(password, { strict: true, login }) || '';
}

export function getConfirmPasswordInlineError(password, confirmPassword) {
    if (!confirmPassword) return '';
    if (password !== confirmPassword) return 'Пароли не совпадают';
    return '';
}
